import { render, staticRenderFns } from "./she80.vue?vue&type=template&id=e5e58404&scoped=true"
import script from "./she80.vue?vue&type=script&lang=ts"
export * from "./she80.vue?vue&type=script&lang=ts"
import style0 from "./she80.vue?vue&type=style&index=0&id=e5e58404&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e58404",
  null
  
)

export default component.exports